import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en-US.json';
import es from './locales/es-MX.json';
import pt from './locales/pt-BR.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'en-US': { translation: en },
      'es-MX': { translation: es },
      'pt-BR': { translation: pt },
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'xnuup_language',
      caches: ['localStorage'],
    },
    fallbackLng: {
      'pt-BR': ['es-MX', 'en-US'],
      'pt':    ['pt-BR', 'es-MX', 'en-US'],
      'es':    ['es-MX', 'en-US'],
      'es-419':['es-MX', 'en-US'],
      'en':    ['en-US'],
      default: ['en-US'],
    },
    supportedLngs: ['en-US', 'es-MX', 'pt-BR'],
    defaultNS: 'translation',
    ns: 'translation',
    interpolation: { escapeValue: false },
    initImmediate: false,
    debug: false,
    react: {
      useSuspense: true,
    },
  });

export default i18n;

export const LOCALE_CONFIG = {
  'en-US': {
    locale: 'en-US',
    currency: 'MXN',
    dateFormat: 'MM/DD/YYYY',
    numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2 },
  },
  'es-MX': {
    locale: 'es-MX',
    currency: 'MXN',
    dateFormat: 'DD/MM/YYYY',
    numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2 },
  },
  'pt-BR': {
    locale: 'pt-BR',
    currency: 'MXN',
    dateFormat: 'DD/MM/YYYY',
    numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2 },
  },
} as const;
